module.exports = __webpack_public_path__ + "img/CrisisAtRWPIncArt1_1920x1080.7061a9cc.png";